import Vue from 'vue'

export default {
    vue: new Vue(),

    emit (event, payload) {
        this.vue.$emit(event, payload)
    },

    on (event, callback) {
        this.vue.$on(event, callback)
    },
}
